<p>Dem Projekt zugeordnete Dokumente:</p>

<clr-datagrid [clrDgLoading]="loading" *transloco="let t; prefix: 'pages.project'">
    <clr-dg-column [clrDgField]="'description'">{{ t('fileDescription') }}</clr-dg-column>
    <clr-dg-column [clrDgField]="'fileName'">{{ t('fileName') }}</clr-dg-column>
    <clr-dg-column [clrDgField]="'document_type'">{{ t('documentType') }}</clr-dg-column>
    <clr-dg-column [clrDgField]="'fileType'">{{ t('fileType') }}</clr-dg-column>
    <clr-dg-column [clrDgField]="'job_number'">{{ t('jobNumber') }}</clr-dg-column>
    <clr-dg-column [clrDgField]="'time'">{{ t('uploadDate') }}</clr-dg-column>
    <clr-dg-column></clr-dg-column>

    <clr-dg-placeholder>Keine Dateien zu Projekt {{ projectId }} vorhanden!</clr-dg-placeholder>

    <clr-dg-row *clrDgItems="let filesA of projectsFiles" [clrDgItem]="filesA">
        <clr-dg-action-overflow>
            <button class="action-item" *ngIf="filesA.fileType === 'application/pdf'" (click)="showModal(filesA.id)">Show PDF</button>
            <button class="action-item" (click)="loadFile(filesA.id, filesA.fileName)">Download</button>
        </clr-dg-action-overflow>
        <clr-dg-cell>{{ filesA.description }}</clr-dg-cell>
        <clr-dg-cell>{{ filesA.fileName }}</clr-dg-cell>
        <clr-dg-cell>{{ t( 'docTypes' + '.' + filesA.document_type.toString() ) }}</clr-dg-cell>
        <clr-dg-cell>{{ filesA.fileType }}</clr-dg-cell>
        <clr-dg-cell><span *ngIf="filesA.job_number > 0" [routerLink]="['/job/details/', filesA.project_number, filesA.job_number]">{{ filesA.project_number }}.0006.{{ filesA.job_number }}</span></clr-dg-cell>
        <clr-dg-cell>{{ filesA.time | date: "dd.MM.yyyy" }}</clr-dg-cell>
        <clr-dg-cell>
            <cds-icon shape="times-circle" class="is-solid" (click)="deleteFile(filesA.id, filesA.fileName)"></cds-icon>&nbsp;
        </clr-dg-cell>
    </clr-dg-row>
</clr-datagrid><br />
<button *ngIf="!showFileUpload" class="btn btn-primary btn-sm" (click)="showFileUploader()">Datei hochladen</button>
<br />
<div *ngIf="showFileUpload">
  <h3>Datei für dieses Projekt hinzufügen</h3>
  <app-upload [componentId]="'0'" [companyId]=0 [projectId]=projectId [jobId]=0 [subId]=0 [docType]=7 (closeModalEvent)="closeModal($event)"></app-upload>
</div>


<p>Zum Projekt gehörende Komponenten/Zeichnungen:</p>

<clr-datagrid [clrDgLoading]="loading" [(clrDgSelected)]="selectedFiles">
    <clr-dg-action-bar *ngIf="selectedFiles.length > 0">
        <div class="btn-group">
            <button type="button" class="btn btn-sm btn-secondary" (click)="downloadZIP(selectedFiles)">
                <cds-icon shape="download"></cds-icon> ZIP-Datei laden
            </button>
        </div>
    </clr-dg-action-bar>
    <clr-dg-column [clrDgField]="'position'">Position</clr-dg-column>
    <clr-dg-column [clrDgField]="'fileName'">Zeichnung</clr-dg-column>
    <clr-dg-column [clrDgField]="'description'">Dateibeschreibung</clr-dg-column>
    <clr-dg-column>Hochgeladen am</clr-dg-column>

    <clr-dg-placeholder>Keine Dateien zu Projekt {{ projectId }} vorhanden!</clr-dg-placeholder>

    <clr-dg-row *clrDgItems="let filesB of componentsFiles" [clrDgItem]="filesB">
        <clr-dg-action-overflow>
            <button class="action-item" *ngIf="filesB.fileType === 'application/pdf'" (click)="showModal(filesB.id)">Show PDF</button>
            <button class="action-item" (click)="loadFile(filesB.id, filesB.fileName)">Download</button>
        </clr-dg-action-overflow>
        <clr-dg-cell>{{ filesB.position }}<span *ngIf="(filesB.part ?? 0) > 0">.{{ filesB.part }}</span></clr-dg-cell>
        <clr-dg-cell [routerLink]="['/component/details', filesB.technical_drawing]">{{ filesB.component_name || filesB.componentName || filesB.name || '-' }}<br /> <span class="small">{{ filesB.technical_drawing }}</span></clr-dg-cell>
        <clr-dg-cell>{{ filesB.description }}</clr-dg-cell>
        <clr-dg-cell>{{ filesB.time | date: "dd.MM.yyyy"  }}</clr-dg-cell>
    </clr-dg-row>
    <clr-dg-footer>Ausgewählte Dateien: {{ selectedFiles.length }}</clr-dg-footer>
</clr-datagrid><br />

<ng-container *ngIf="showPdf">
    <clr-modal id="pdfViewer" [(clrModalOpen)]="showPdf" [clrModalStaticBackdrop]="false">
        <h3 class="modal-title">{{ modalContent }}</h3>
        <div class="modal-body">
            <ngx-extended-pdf-viewer [src]="modalUrl" useBrowserLocale="true" height="85vh" [textLayer]="true"></ngx-extended-pdf-viewer>
        </div>
    </clr-modal>
</ng-container>
